import React from 'react';
import {
	Box,
	Spacer,
	Typography,
	Image,
	useTheme,
	ComposableTypography,
} from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import { ModalLocal, Link } from '@components';
import { modals } from '@modals';
import { imagesBcp } from '@assets';
import { Close } from '@icons';
import { rem } from '@helpers';
import { Anything } from '@types';
import { PhoneBadges } from './errorCaeOrAml.components';
import { useErrorCaeOrAmlHelper } from './errorCaeOrAml.helper';

export const ErrorCaeOrAml: React.FC = () => {
	const { palette } = useTheme();
	const { resources, typeError, onCloseRequest } = useErrorCaeOrAmlHelper();
	const typographyAppearance = 'body-100-02';
	const typographyColor = '#80828F';
	return (
		<ModalLocal
			name={modals.errorCaeOrAml}
			contentCustomStyle={{
				padding: 0,
				width: rem(596),
			}}
			closeIcon={{
				source: Close,
				svgProps: {
					styles: {
						width: 132,
						height: 132,
					},
				},
			}}
			showCloseButton
			onCloseRequest={onCloseRequest}
			containerCloseIconStyle={{
				left: '',
				bottom: '',
				right: rem(30),
				top: rem(20),
			}}
			middleContent={{
				type: 'custom',
				content: (
					<>
						<Box styles={{ width: '100%' }}>
							<Image
								source={imagesBcp.izibiziImage}
								styles={{ width: '100%', borderTopLeftRadius: rem(16), borderTopRightRadius: rem(16) }}
							/>
						</Box>
						<Box styles={{ backgroundColor: palette.primary.p1, height: rem(4), width: '100%' }} />
						<Box styles={{ padding: `${rem(32)}`, flexDirection: 'column', width: '100%' }}>
							<ComposableTypography
								text={typeError === 'AML' ? resources.titleAML : resources.titleCAE}
								baseProps={{ appearance: 'subtitle-100-02' }}
								tags={{
									b: {
										appearance: 'subtitle-100-04',
									},
								}}
							/>
							<Spacer vertical={rem(16)} />
							{typeError === 'AML' ? (
								<Typography
									appearance={typographyAppearance}
									alternativeStyleProperties={{ color: typographyColor } as Anything}
								>
									{resources.subtitleAML}
								</Typography>
							) : (
								<Box>
									<Typography
										appearance={typographyAppearance}
										alternativeStyleProperties={{ color: typographyColor } as Anything}
									>
										{resources.subtitleCAE1}{' '}
										<Link redirectUrl={resources.subtitleCAELink} target={'_blank'}>
											<Typography appearance={typographyAppearance} colorsLevel={'linkDefault'}>
												{resources.subtitleCAEtextLink}
											</Typography>
										</Link>{' '}
										{resources.subtitleCAE2}
									</Typography>
								</Box>
							)}
							<Spacer vertical={rem(32)} />
							<Box
								styles={{
									padding: `${rem(24)}`,
									borderRadius: rem(16),
									backgroundColor: palette.background.b2,
									flexDirection: 'column',
									width: '100%',
									alignItems: 'center',
								}}
							>
								<Box
									styles={{
										width: '100%',
										justifyContent: 'space-around',
									}}
								>
									<PhoneBadges />
								</Box>
								<Spacer vertical={rem(32)} />
								<Typography
									appearance="microcopy-75-02"
									alternativeStyleProperties={
										{ color: typographyColor, lineHeight: '15px', textAlign: 'center' } as Anything
									}
								>
									{resources.footerTitle}
								</Typography>
								<Spacer vertical={rem(16)} />
								<Typography
									appearance="microcopy-75-02"
									alternativeStyleProperties={
										{ color: typographyColor, lineHeight: '15px', textAlign: 'center' } as Anything
									}
								>
									{resources.footerSubtitle}
								</Typography>
							</Box>
						</Box>
					</>
				),
			}}
			closeOnPressOutside={false}
		/>
	);
};
